import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-czujki',
  templateUrl: './page-czujki.component.html',
  styleUrls: ['./page-czujki.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageCzujkiComponent implements OnInit {

  public randomizeText = "Teraz czas na uruchomienie maszyny losującej z nacechowanymi emocjonalnie formantami słowotwórczymi. Losuj końcówki, uruchom kreatywność i twórz nowe słowa, zdrobnienia czy zgrubienia."
  public taskId: number;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.taskId = this.route.snapshot.params['id'];
  }

}
